import api from '../../utils/api';
import store from '../index';

const state = {
	isLoggedIn: false,
	isPhoneVerified: false,
	emailIsVerified: false,
	otpSent: false,
	userBio: null,
	phone: null,
	docType: '',
	doc: '',
	bvn: '',
	accountNumber: '',
	monoAuthCode: '',
	bankName: '',
	loanAmount: null,
	isUserEligible: false,
	completeCheckout: false,
	email: null,
	password: null,
	loggedUser: {},
	isBankConnected: false,
	token: null,
	isEmailVerified: false,
	/**
	 * payload is populated from
	 * data from merchant
	 */
	payload: null,
	isLoading: false,
	paymentLinkResponse: null,
	forgetPasswordPayload: {},
	otp: '',
	signInPreQualifyUser: null,
	card: null,
	monoUserId: null,
	showBvnModal: false,
	userAvatar: '',
	userPagaConnectData: false,
	recommendedAmount: null,
	initiateBvnLookUpResponse: null,
	selectedBvnVerificationContact: null
};

const getters = {
	getLoggedUser: (state) => state.loggedUser,
	getIsPhoneVerified: (state) => state.isPhoneVerified,
	getEmailIsVerified: (state) => state.emailIsVerified,
	getOtpStatus: (state) => state.otpSent,
	getUserBio: (state) => state.userBio,
	getDocType: (state) => state.docType,
	getDoc: (state) => state.doc,
	getPhone: (state) => state.phone,
	getEmail: (state) => state.email,
	getBvn: (state) => state.bvn,
	getAccountNumber: (state) => state.accountNumber,
	getIsBankConnected: (state) => state.isBankConnected,
	getMonoAuthCode: (state) => state.monoAuthCode,
	getBankName: (state) => state.bankName,
	getLoanAmount: (state) => state.loanAmount,
	getIsUserEligible: (state) => state.isUserEligible,
	getIsLoading: (state) => state.isLoading,
	getCompleteCheckout: (state) => state.completeCheckout,
	getPayload: (state) => state.payload,
	getPassword: (state) => state.password,
	isLoggedIn: (state) => state.isLoggedIn,
	getToken: (state) => state.token,
	getIsEmailVerified: (state) => state.isEmailVerified,
	getPaymentLinkResponse: (state) => state.paymentLinkResponse,
	getForgetPasswordPayload: (state) => state.forgetPasswordPayload,
	getOtp: (state) => state.otp,
	getSignInPreQualifyUser: (state) => state.signInPreQualifyUser,
	getCard: (state) => state.card,
	getMonoUserId: (state) => state.monoUserId,
	getShowBvnModal: (state) => state.showBvnModal,
	getUserAvatar: (state) => state.userAvatar,
	getUserPagaConnectData: (state) => state.userPagaConnectData,
	getRecommendedAmount: (state) => state.recommendedAmount,
	getInitiateBvnLookUpResponse: (state) => state.initiateBvnLookUpResponse,
	getSelectedBvnVerificationContact: (state) => state.selectedBvnVerificationContact
};

const mutations = {
	setLoggedUser: (state, user) => {
		state.loggedUser = user;
		state.isLoggedIn = true;
	},
	setOtpStatus: (state, bool) => {
		state.otpSent = bool;
	},
	setUserBio: (state, data) => {
		state.userBio = data;
	},
	setDocType: (state, type) => {
		state.docType = type;
	},
	setDoc: (state, file) => {
		state.doc = file;
	},
	setBvn: (state, bvn) => {
		state.bvn = bvn;
	},
	setAccountNumber: (state, account_number) => {
		state.accountNumber = account_number;
	},
	setIsBankConnected: (state, bool) => {
		state.isBankConnected = bool;
	},
	setMonoAuthCode: (state, code) => {
		state.monoAuthCode = code;
	},
	setBankName: (state, name) => {
		state.bankName = name;
	},
	setLoanAmount: (state, amount) => {
		state.loanAmount = amount;
	},
	setIsUserEligible: (state, bool) => {
		state.isUserEligible = bool;
	},
	setIsLoading: (state, bool) => {
		state.isLoading = bool;
	},
	setCompleteCheckout: (state, bool) => {
		state.completeCheckout = bool;
	},
	setPayload: (state, data) => {
		state.payload = data;
	},
	updateToken: (state, data) => {
		state.token = data;
	},
	setPhone: (state, data) => {
		state.phone = data;
	},
	setEmail: (state, email) => {
		state.email = email;
	},
	setPassword: (state, password) => {
		state.password = password;
	},
	setPhoneVerified: (state, bool) => {
		state.isPhoneVerified = bool;
	},
	setEmailVerified: (state, bool) => {
		state.emailIsVerified = bool;
	},
	setIsEmailVerified: (state, bool) => {
		state.isEmailVerified = bool;
	},
	setPaymentLinkResponse: (state, data) => {
		state.paymentLinkResponse = data;
	},
	setForgetPasswordPayload: (state, data) => {
		state.forgetPasswordPayload = {
			...state.forgetPasswordPayload,
			...data
		};
	},
	setOtp: (state, data) => {
		state.otp = data;
	},
	setSignInPreQualifyUser: (state, data) => {
		state.signInPreQualifyUser = data;
	},
	setCard: (state, data) => {
		state.card = data;
	},
	setMonoUserId: (state, id) => {
		state.monoUserId = id;
	},
	setShowBvnModal: (state, data) => {
		state.showBvnModal = data;
	},
	setUserAvatar: (state, data) => {
		state.userAvatar = data;
	},
	setUserPagaConnectData: (state, data) => {
		state.userPagaConnectData = data;
	},
	setRecommendedAmount: (state, recommendedAmount) => {
		state.recommendedAmount = recommendedAmount;
	},
	setInitiateBvnLookUpResponse: (state, data) => {
		state.initiateBvnLookUpResponse = data;
	},
	setSelectedBvnVerificationContact: (state, data) => {
		state.selectedBvnVerificationContact = data;
	}
};

const actions = {
	signIn: ({ commit }, data) => {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		delete data.terms;
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		api.post('login', data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then((response) => {
				commit('setLoggedUser', response.data);
				commit('updateToken', response.token);
				commit('setIsLoading', false);
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				commit('reqError', null, { root: true });
				const errorData = JSON.parse(error);
				commit('setIsLoading', false);
				commit('setErrorMessage', errorData.message);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},
	generatePhoneOtp({ commit }, data) {
		commit('setIsLoading', true);
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		api.postSetHeader('register/phone-otp', data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				return response.json();
			})
			.then((response) => {
				commit('setPhone', data.phone);
				commit('setOtpStatus', true);
				commit('setAlert', {
					type: 'success',
					message: response.message
				});
				commit('setIsLoading', false);
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setOtpStatus', false);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},
	verifyPhoneOtp({ commit }, data) {
		commit('setIsLoading', true);
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		api.post('register/phone-otp-verify', data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				return response.json();
			})
			.then((response) => {
				commit('setPhoneVerified', response.data.is_validated);
				commit('setIsLoading', false);
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setPhoneVerified', false);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},
	verifyEmailOtp({ commit }, data) {
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('setIsLoading', true);
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		api.post('auth/password-email-otp-verify', data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				return response.json();
			})
			.then((response) => {
				commit('reqSuccess', null, { root: true });
				commit('setEmailVerified', response.data.is_validated);
				commit('setIsLoading', false);
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				const errorData = JSON.parse(error);
				commit('setEmailVerified', false);
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},
	forgetPassword({ commit }, data) {
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('setIsLoading', true);
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		api.patch('auth/change-password', data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then((response) => {
				commit('setAlert', {
					type: 'success',
					message: response.message
				});
				commit('setForgetPasswordPayload', {});
				commit('setIsLoading', false);
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},
	verifyUserId({ commit }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		api.postSetHeader('register/pre-qualify/validate-id', data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				return response.json();
			})
			.then((response) => {
				commit('setAlert', {
					type: 'success',
					message: response.message
				});
				commit('setDoc', data.file);
				commit('reqSuccess', null, { root: true });
				commit('setIsLoading', false);
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},
	prequalifyUser({ commit }, data) {
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		api.post('register/pre-qualify', data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				return response.json();
			})
			.then(() => {
				commit('setIsUserEligible', true);
			})
			.catch(async (response) => {
				commit('reqError', null, { root: true });
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},
	async verifyEmail({ commit }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		return api
			.post('register/verify-email', data)
			.then((response) => {
				if (response.status !== 200) {
					return Promise.reject(response);
				}
				return true;
			})
			.then(() => {
				commit('setIsEmailVerified', true);
				commit('setEmail', data.email);
				commit('setIsLoading', false);
				commit('reqSuccess', null, { root: true });
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				commit('setIsEmailVerified', false);
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},
	async verifyForgetPasswordEmail({ commit }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		return api
			.post('auth/password', data)
			.then((response) => {
				if (response.status !== 200) {
					return Promise.reject(response);
				}
				return response.json();
			})
			.then((response) => {
				commit('setAlert', {
					type: 'success',
					message: response.message
				});
				commit('setIsEmailVerified', true);
				commit('setEmail', data.email);
				commit('setIsLoading', false);
				commit('reqSuccess', null, { root: true });
				return true;
			})
			.catch(async (response) => {
				commit('reqError', null, { root: true });
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				commit('setIsEmailVerified', false);
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},
	createTransaction({ commit }, data) {
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		api.post('transactions', data)
			.then((response) => {
				if (response.status !== 200 && response.status !== 201) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setPaymentLinkResponse', response);
				if (response.type === 'returning_customer') {
					commit('setIframeResponseOnSuccess', {
						status: true,
						type: 'SUCCESS',
						data: {
							status: 'successful',
							data: {
								reference: response.result.reference,
								redirect_url:
									typeof response.redirect_url !== 'undefined' ? response.redirect_url : false
							}
						}
					});
				}
			})
			.catch(async (response) => {
				commit('reqError', null, { root: true });
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},
	pagaCreateTransaction({ commit }, data) {
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		api.post('transactions/new', data)
			.then((response) => {
				if (response.status !== 200 && response.status !== 201) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setPaymentLinkResponse', response);
				if (response.type === 'returning_customer') {
					commit('setIframeResponseOnSuccess', {
						status: true,
						type: 'SUCCESS',
						data: {
							status: 'successful',
							data: {
								reference: response.result.reference,
								redirect_url:
									typeof response.redirect_url !== 'undefined' ? response.redirect_url : false
							}
						}
					});
				}
			})
			.catch(async (response) => {
				commit('reqError', null, { root: true });
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},
	preQualifyingReturningUser({ commit }, data) {
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		api.returningUserPost('users/pre-qualify-returning', data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then((response) => {
				commit('setSignInPreQualifyUser', response);
				commit('setAlert', {
					type: 'success',
					message: response.message
				});
				commit('setIframeResponseOnLoad', {
					status: false,
					type: 'LOADING'
				});
			})
			.catch(async (response) => {
				commit('reqError', null, { root: true });
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setAlert', {
					type: 'danger',
					message: errorData.message
				});
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},
	async verifyBvn({ commit }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		return api
			.postSetHeader('register/pre-qualify/validate-bvn', data)
			.then((response) => {
				if (response.status !== 200) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				commit('setBvn', data.bvn);
				return true;
			})
			.then(() => {
				commit('setIsLoading', false);
				return true;
			})
			.catch(async (response) => {
				commit('reqError', null, { root: true });
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},

	//
	async verifyKycBvn({ commit }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		return api
			.postSetHeader('register/pre-qualify/validate-kyc-bvn', data)
			.then((response) => {
				if (response.status !== 200) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				commit('setBvn', data.bvn);
				return response.json();
			})
			.then((response) => {
				commit('setBvn', response.data.bvn);
				commit('setMonoUserId', response.data.mono_user_id);
				commit('setAccountNumber', response.data.account_number);
				commit('setIsLoading', false);
				return true;
			})
			.catch(async (response) => {
				commit('reqError', null, { root: true });
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},

	async verifyKyc({ commit }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		return api
			.post('register/pre-qualify/validate-kyc', data)
			.then((response) => {
				if (response.status === 428) {
					commit('setShowBvnModal', true);
					return Promise.reject(response);
				}
				if (response.status !== 200 && response.status !== 428) {
					return Promise.reject(response);
				}
				commit('setIsLoading', false);
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then((response) => {
				commit('setBvn', response.data.bvn);
				commit('setMonoUserId', response.data.mono_user_id);
				commit('setAccountNumber', response.data.account_number);
				commit('setAlert', {
					type: 'success',
					message: response.message
				});
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				commit('reqError', null, { root: true });
				commit('setIsEmailVerified', false);
				const errorData = JSON.parse(error);
				if(errorData.message === 'Your session has expired. Please go back and link your bank account') {
					commit('setIsMonoAuthCodeError', true);
				}
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},
	async userAccountStatus({ commit }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		store.commit('setBankRecord2MinutesFailure', false);
		return api
			.post('register/pre-qualify/account-status', data)
			.then((response) => {
				if (response.status !== 200) {
					return Promise.reject(response);
				}
				commit('setIsLoading', false);
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then((response) => {
				commit('setIsLoading', false);
				commit('setAlert', {
					type: 'success',
					message: response.message
				});
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				commit('reqError', null, { root: true });
				const bankRecordFailureCounter = store.state.bankRecordFailureCounter + 1;
				commit('setBankRecordFailureCounter', bankRecordFailureCounter);
				commit('setIsEmailVerified', false);
				const errorData = JSON.parse(error);
				if(errorData.message === 'Your bank is yet to send your account details to us. Please wait for 2 minutes and click the button again below') {
					commit('setBankRecord2MinutesFailure', true);
				}
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},

	async captureUserLivePhoto({ commit }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		return api
			.postSetHeader('register/pre-qualify/passport-photograph', data)
			.then((response) => {
				if (response.status !== 200) {
					return Promise.reject(response);
				}
				return response.json();
			})
			.then((response) => {
				commit('setUserAvatar', response.data);
				commit('setIsLoading', false);
				commit('reqSuccess', null, { root: true });
				commit('setAlert', {
					type: 'success',
					message: response.message
				});
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				commit('reqError', null, { root: true });
				commit('setIsEmailVerified', false);
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
				return false;
			});
	},
	async reauthorizeMono({ commit }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		return api
			.patchReauthorizeMono(`users/${data.id}/bank-re-authorization`, data)
			.then((response) => {
				if (response.status !== 200) {
					return Promise.reject(response);
				}
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				commit('reqSuccess', null, { root: true });
				return response;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				commit('reqError', null, { root: true });
				commit('setIsEmailVerified', false);
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
			});
	},
	async saveMerchantPayload({ commit }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		return api
			.post('transactions/temp', data)
			.then((response) => {
				if (response.status !== 200) {
					return Promise.reject(response);
				}
				commit('setIsLoading', false);
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(() => {
				commit('setIsLoading', false);
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				commit('reqError', null, { root: true });
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
				commit('setAlert', {
					type: 'danger',
					message: errorData.message
				});
			});
	},

	async returningUserPhoneOtp({ commit }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		return api
			.post('phone-otp ', data)
			.then((response) => {
				if (response.status !== 200) {
					return Promise.reject(response);
				}
				commit('setIsLoading', false);
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(() => {
				commit('setIsLoading', false);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				commit('reqError', null, { root: true });
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
				commit('setAlert', {
					type: 'danger',
					message: errorData.message
				});
			});
	},

	async checkIfUserIsConnectToPaga({ commit }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		return api
			.post('users/paga/check-connect', data)
			.then((response) => {
				if (response.status !== 200) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then((data) => {
				commit('setUserPagaConnectData', data.connected);
				commit('setIsLoading', false);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				commit('reqError', null, { root: true });
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
				commit('setIframeResponseOnError', {
					message: errorData.message,
					type: 'ERROR'
				});
				commit('setAlert', {
					type: 'danger',
					message: errorData.message
				});
			});
	},
	async initiateBvnLookUp({ commit }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		return api
			.post('register/pre-qualify/initiate-bvn-lookup', data)
			.then((response) => {
				if (response.status !== 200) {
					return Promise.reject(response);
				}
				return response.json();
			})
			.then((response) => {
				commit('setIsLoading', false);
				commit('reqSuccess', null, { root: true });
				commit('setInitiateBvnLookUpResponse', response.data);
				commit('setAlert', {
					type: 'success',
					message: response.message
				});
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				commit('reqError', null, { root: true });
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
			});
	},
	async postBvnVerificationMethod({ commit }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		return api
			.post('register/pre-qualify/bvn-otp', data)
			.then((response) => {
				if (response.status !== 200) {
					return Promise.reject(response);
				}
				return response.json();
			})
			.then((response) => {
				commit('setIsLoading', false);
				commit('reqSuccess', null, { root: true });
				commit('setAlert', {
					type: 'success',
					message: response.message
				});
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				commit('reqError', null, { root: true });
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
			});
	},
	async verifyBvnOtp({ commit }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		return api
			.post('register/pre-qualify/verify-bvn-otp', data)
			.then((response) => {
				if (response.status !== 200) {
					return Promise.reject(response);
				}
				return response.json();
			})
			.then((response) => {
				commit('setIsLoading', false);
				commit('reqSuccess', null, { root: true });
				commit('setAlert', {
					type: 'success',
					message: response.message
				});
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				commit('reqError', null, { root: true });
				const errorData = JSON.parse(error);
				commit('setErrorMessage', errorData.message);
				commit('setIsLoading', false);
			});
	}
};

export default {
	actions,
	state,
	mutations,
	getters
};
